import type { ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { AppShell, Header, RequestIndicator, ThemeToggle, ToastViewport, useAuth } from 'grabbitbot-legacy-ui'
import { apiClient } from '../api/client'
import { APP_VERSION, BRAND } from '../config'

function NavLink({ to, children }: { to: string; children: ReactNode }) {
  const location = useLocation()
  const active = location.pathname === to || location.pathname.startsWith(`${to}/`)
  return (
    <Link to={to} aria-current={active ? 'page' : undefined} className={active ? 'active' : undefined}>
      {children}
    </Link>
  )
}

export function Shell({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth()

  return (
    <AppShell
      header={
        user ? (
          <Header
            title={<Link to="/wallets">{BRAND}</Link>}
            nav={
              <div className="wnf-nav">
                <NavLink to="/wallets">Wallets</NavLink>
                <NavLink to="/swap">Swap</NavLink>
                <NavLink to="/orders/open">Open orders</NavLink>
                <NavLink to="/orders/history">Order history</NavLink>
                <NavLink to="/service-accounts">Service accounts</NavLink>
              </div>
            }
            actions={
              <div className="wnf-actions">
                <RequestIndicator client={apiClient} />
                <ThemeToggle />
                <NavLink to="/user">{user.username}</NavLink>
                <button type="button" onClick={logout}>
                  Log out
                </button>
              </div>
            }
          />
        ) : undefined
      }
    >
      {children}
      <footer className="wnf-footer">
        {BRAND} v{APP_VERSION} — simulated exchange, test funds only
      </footer>
      <ToastViewport />
    </AppShell>
  )
}
